import IComponent from "components/commons/IComponent";
import MiniPanel from "components/commons/MiniPanel";

import Button from "@material-ui/core/Button";
import SwitchButton from "components/commons/SwitchButton";
import "./SearchUI.scoped.css";
import Grid from "@material-ui/core/Grid";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ReactDOM from "react-dom";
import PopupMapSheetSelection from "components/LayerSetting/New3DLayerSetting/PopupMapSheetSelection";
import {
  updateSearchResults,
  setLayer3DSearchZoomTo1st,
} from "store/globalSlice";
import LayerToggleUtil from "utils/LayerToggleUtil";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
// import config_searchUI from "./config_searchUI";
import config_searchUI from "components/ZoomTo/config_zoomto";
import MapSheet from "utils/MapSheet";
import GetArcGISToken from "utils/GetArcGISToken";
import slopeNoFormat from "utils/slopeNoFormat";

import { Checkbox, FormControlLabel } from "@material-ui/core";

let MAX_SELECTION = null;

let list = [
  { type: "Unclassifed", checked: true },
  { type: "Low vegetation", checked: true },
  { type: "High vegetation", checked: true },
  { type: "Transmission tower", checked: true },
  { type: "Ground", checked: true },
  { type: "Medium vegetation", checked: true },
  { type: "Building", checked: true },
];

class SearchUI extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      filterKeyword: "",
      categories: {},
      searchByGrid: false,
      showGrid: false,
      block: [],
      tmpBlock: [],
      pointCloudClass: false,
    };
    this.userOptions = {
      year: null,
      yearDropdownValue: undefined,
    };
    MAX_SELECTION = GetArcGISToken.user.isAdmin ? 8 : 2;
  }

  componentDidMount() {}
  componentWillUnmount() {}

  search3DLayerByText(freeText) {
    // freeText = freeText.trim();
    let layerList = this.$config.mapList.layer3D;
    let freeTextSlopeNo = slopeNoFormat.FeatureNo13Char(freeText);
    let uavFlightLayers = [];
    let value = Object.keys(layerList).reduce((p, c, i) => {
      var categoryItem = layerList[c];
      categoryItem = categoryItem.reduce((pV, cV, iV) => {
        if (
          (cV.metaData?.slopeNo || {})[freeTextSlopeNo] ||
          (cV.metaData?.location || "").toLowerCase() === freeText
        ) {
          pV.push(iV);
        }

        if (cV.title === "UAV Image Point" || cV.title === "UAV Flight Path")
          uavFlightLayers.push(iV);
        return pV;
      }, []);
      if (categoryItem.length > 0) {
        if (c === "UAV") categoryItem.push.apply(categoryItem, uavFlightLayers);
        p[c] = categoryItem;
      }
      return p;
    }, {});

    this.props.reduxCallProxy(updateSearchResults, value);
    this.props.reduxCallProxy(setLayer3DSearchZoomTo1st, true);

    let resultExpandBtn = document.querySelector(
      // ".new3DLayerPanelExpandContainer .esri-expand__mask"
      '[id="3DLayerSearchResult"] .esri-expand__mask'
    );
    console.log(resultExpandBtn);
    if (resultExpandBtn.className.indexOf("esri-expand__mask--expanded") === -1)
      // resultExpandBtn.click();
      setTimeout(() => resultExpandBtn.click());
  }

  search3DLayer(layerList, categories) {
    console.log(categories);
    this.startNewSearchSession();

    let block = this.state.block;
    let availList = this.$config.AvailLayerList;
    let extent = this.props.mapView.extent;

    let selectedYear = this.userOptions.year
      ? this.userOptions.year.toString()
      : "";
    let new_block = this.state.searchByGrid
      ? block.reduce((bpV, bcV, biV) => {
          bpV.push(MapSheet[bcV]);
          return bpV;
        }, [])
      : [];

    if (
      new_block.length === 0 &&
      MapSheet.filterKey(extent).length > MAX_SELECTION
    ) {
      this.props.showDialog({
        type: "info",
        isOpen: true,
        title: "Map Range is too large",
        content:
          "The searching range is too large. Please zoom in the map to get narrow result!",
        onDialogOk: () => {},
      });
      return;
    }

    let uavFlightLayers = [];
    let value = Object.keys(layerList.layer3D).reduce((p, c, i) => {
      var categoryItem = layerList.layer3D[c];
      var availListItem = availList.layer3D[c];

      // Check if the category is checked
      if (!categories[c]) {
        return p;
      }

      categoryItem = categoryItem.reduce((pV, cV, iV) => {
        if (cV.title === "UAV Image Point" || cV.title === "UAV Flight Path") {
          uavFlightLayers.push(iV);
          return pV;
        }

        let result = false;
        if (new_block.length > 0) {
          // Check if the user wanted to search by grid (map sheet block(s) is selected)
          result = new_block.some(
            (i) => !i || i.intersects(availListItem[iV].extent)
          );
        } else {
          result = !cV.extent || extent.intersects(availListItem[iV].extent);
        }

        if (result) {
          pV.push(iV);
        }
        return pV;
      }, []);

      switch (c) {
        case "Landslide Incident":
        case "Others":
        case "UAV":
          if (selectedYear) {
            categoryItem = categoryItem.filter((i) => {
              let info = layerList.layer3D[c][i];
              return (
                info?.tags &&
                info.tags.some((j) => {
                  j = j.substr(3);
                  return j === selectedYear;
                })
              );
            });
          }
          break;
        default:
          break;
      }

      p[c] = categoryItem;
      console.log(categoryItem);
      return p;
    }, {});

    Object.keys(value).forEach(
      (i) => Object.keys(value[i]).length === 0 && delete value[i]
    );

    if ("UAV" in value) {
      value.UAV.push.apply(value.UAV, uavFlightLayers);
    }

    this.props.reduxCallProxy(updateSearchResults, value);
    let resultExpandBtn = document.querySelector('[title="3D Layer Panel"]');
    if (resultExpandBtn.className.indexOf("esri-expand__mask--expanded") === -1)
      setTimeout(() => resultExpandBtn.click());
  }

  onChangeHandler(field, value, values) {
    console.log("3D Map Layer Drop down Change ", field, value, values);
    this.userOptions.yearDropdownValue = value;
    this.userOptions.year = value && values[value];
    this.setState({});
  }

  onSelectedSheets(selectedBlock) {
    this.setState({
      block: selectedBlock,
    });
  }

  startNewSearchSession() {
    this.props.reduxCallProxy(updateSearchResults, undefined);
    this.props.reduxCallProxy(setLayer3DSearchZoomTo1st, false);
    LayerToggleUtil.removeAdded3DLayers(this.props.mapView);
  }

  render() {
    let layerList = this.$config.mapList;
    let { categories, searchByGrid, showGrid, block } = this.state;
    let disabled =
      Object.keys(categories).some((i) => categories[i] == true) &&
      (block.length > 0 || !searchByGrid);
    let userOptions = this.userOptions;
    let abled = Object.keys(categories).some((i) => categories[i] === true);

    if (!layerList) return <i>No data</i>;
    return (
      <>
        <div className="newLayer3DMapLayerPanel">
          <div className="SubPanelContent newLayer3DMapLayerDiv">
            {" "}
            3D LAYER SEARCH
          </div>
          <div>
            <div className="EqualWidthChildren toggle">
              <ToggleButtonGroup orientation="vertical" exclusive>
                <ToggleButton
                  selected={!!categories["Man-made Feature"]}
                  aria-label="list"
                  onClick={() => {
                    categories["Man-made Feature"] = !categories[
                      "Man-made Feature"
                    ];
                    this.setState({ categories });
                  }}
                >
                  <span>Man-made Feature</span>
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
            <div className="toggle">
              <ToggleButtonGroup
                orientation="vertical"
                className="Toggle3Button"
              >
                <ToggleButton
                  selected={!!categories["Landslide Incident"]}
                  aria-label="list"
                  className="toggleItem"
                  onClick={() => {
                    categories["Landslide Incident"] = !categories[
                      "Landslide Incident"
                    ];
                    this.setState({ categories });
                  }}
                >
                  <span>Landslide Incident</span>
                </ToggleButton>
                <ToggleButton
                  selected={!!categories["Others"]}
                  aria-label="list"
                  className="toggleItem"
                  onClick={() => {
                    categories["Others"] = !categories["Others"];
                    this.setState({ categories });
                  }}
                >
                  <span>Others</span>
                </ToggleButton>
                <ToggleButton
                  selected={!!categories["UAV"]}
                  aria-label="list"
                  onClick={() => {
                    categories["UAV"] = !categories["UAV"];
                    this.setState({ categories });
                  }}
                >
                  <span>UAV</span>
                </ToggleButton>
                <ToggleButton
                  selected={!!categories["Tunnel"]}
                  aria-label="list"
                  onClick={() => {
                    categories["Tunnel"] = !categories["Tunnel"];
                    this.setState({ categories });
                  }}
                >
                  <span>Tunnel</span>
                </ToggleButton>
              </ToggleButtonGroup>
              {/* <EditableDatagridCell
                key="dropdown_year"
                style={{ textAlign: "center" }}
                className="dropdownYear"
                disabled={
                  !categories["Landslide Incident"] &&
                  !categories["UAV"] &&
                  !categories["Others"]
                }
                cellInfo={{
                  colDef: {
                    field: "yearDropdownValue",
                    dataType: "dropdown",
                    values:
                      config_searchUI.Search_Input_Values[
                        "textual_dropdown_uav_years"
                      ],
                    naText: "Select Year",
                  },
                  row: userOptions,
                  key: "dropdown_year",
                }}
                onChange={this.onChangeHandler.bind(this)}
              /> */}
            </div>
            <div className="EqualWidthChildren toggle">
              <ToggleButtonGroup
                orientation="vertical"
                // value={"list"}
                exclusive
                // onChange={}
              >
                <ToggleButton
                  selected={!!categories["3D Geotechnical Model"]}
                  aria-label="list"
                  onClick={() => {
                    categories["3D Geotechnical Model"] = !categories[
                      "3D Geotechnical Model"
                    ];
                    this.setState({ categories });
                  }}
                >
                  <span>3D Geotechnical Model</span>
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
            <div className="EqualWidthChildren toggle">
              <ToggleButtonGroup
                orientation="vertical"
                // value={"list"}
                exclusive
                // onChange={}
              >
                <ToggleButton
                  selected={!!categories["BIM Model"]}
                  aria-label="list"
                  onClick={() => {
                    categories["BIM Model"] = !categories["BIM Model"];
                    this.setState({ categories });
                  }}
                >
                  <span>BIM Model</span>
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
          </div>
          <div>
            {true && (
              <div className="panelTitle GridDiv">
                <SwitchButton
                  label={"Select on Map Sheet"}
                  disableLabelClick={true}
                  placeAtRight={true}
                  checked={searchByGrid}
                  onClick={() => {
                    this.setState({
                      searchByGrid: !searchByGrid,
                      showGrid: !searchByGrid,
                      block: !searchByGrid ? [] : block,
                    });
                  }}
                  needMidICON={searchByGrid}
                  midICONClassName={"icn_zoomtolayer"}
                  midICONOnClick={() => {
                    this.setState({ showGrid: !showGrid });
                  }}
                  style={{ width: "22px" }}
                />
              </div>
            )}
            {showGrid &&
              ReactDOM.createPortal(
                <PopupMapSheetSelection
                  maxSelection={MAX_SELECTION}
                  selectedBlock={block}
                  onSelectedSheets={(e) => this.onSelectedSheets(e)}
                  onClose={() => this.setState({ showGrid: false })}
                />,
                this.props.mapView.container.querySelector(
                  ".esri-ui-manual-container"
                )
              )}

            <div className="EqualWidthChildren">
              <div className="buttonFirstDiv">
                <Button
                  className="clearbutton"
                  variant="contained"
                  onClick={() => {
                    let vm = this;
                    let cat = {
                      "Man-made Feature": true,
                      "Landslide Incident": true,
                      Others: true,
                      UAV: true,
                      Tunnel: true,
                      "3D Geotechnical Model": true,
                      "BIM Model": true,
                    };

                    this.setState({
                      categories: cat,
                      // searchByGrid: false,
                      // showGrid: false,
                    });
                    // this.startNewSearchSession();
                  }}
                >
                  {" "}
                  {
                    <span
                      style={abled ? { color: "#54719D" } : { color: "grey" }}
                    >
                      {/* CLEAR ALL */}
                      SELECT ALL
                    </span>
                  }
                </Button>
              </div>
              <Button
                className="searchbutton"
                variant="contained"
                disabled={!disabled}
                onClick={() => {
                  this.startNewSearchSession();
                  setTimeout(() => this.search3DLayer(layerList, categories));
                }}
              >
                <span>SEARCH</span>
                <span>&nbsp;</span>
                <span className="icn_menu_search" />
              </Button>
            </div>
          </div>
        </div>
        <div className="EqualWidthChildren MapSearchInput">
          <EditableDatagridCell
            cellInfo={{
              colDef: {
                field: "filterKeyword",
                dataType: "text",
                hint: "Enter Location or Slope No.",
              },
              row: this.state,
            }}
            onChange={(a, v) =>
              this.setState({
                filterKeyword: v.toLowerCase(),
                // filter: false,
              })
            }
            onEnterKeyPress={function() {
              this.startNewSearchSession();
              setTimeout(() =>
                this.search3DLayerByText(this.state.filterKeyword)
              );
            }.bind(this)}
          />
          <Button
            classes={{ root: "actionBtn" }}
            variant="contained"
            disabled={!!(this.state.filterKeyword === "")}
            onClick={() => {
              this.startNewSearchSession();
              setTimeout(() =>
                this.search3DLayerByText(this.state.filterKeyword)
              );
            }}
            style={{ height: "57.5px" }}
          >
            <span className="icn_menu_search icon_s" />
          </Button>
        </div>

        <div style={{ marginBottom: "100px", display: "none" }}>
          {/* <MiniPanel
                        titleClass="ListTitle ListItemBottomLine" titleText="3D Spatial Dataset (LandsD)"
                    >
                    </MiniPanel>
                    <MiniPanel
                        titleClass="ListTitle ListItemBottomLine" titleText="Photorealistic Mesh Model (LandsD & PlanD)"
                    >
                    </MiniPanel> */}
          <hr />
          <MiniPanel
            collapsed={false}
            titleText={
              <SwitchButton
                label={<i>New Point Cloud Class</i>}
                placeAtRight={true}
                checked={this.state.pointCloudClass}
                onClick={() => {
                  // l.visible = !l.visible;
                  // vm.setState({});
                  this.setState({
                    pointCloudClass: !this.state.pointCloudClass,
                  });
                }}
                style={{ width: "22px" }}
              />
            }
          >
            {this.state.pointCloudClass && (
              <div style={{ display: "grid", marginLeft: "20px" }}>
                {list.map((i) => (
                  <FormControlLabel
                    key={`${Math.random()}`}
                    value={i.type}
                    style={this.props.compact ? { height: "25px" } : undefined}
                    control={
                      <Checkbox
                        key={`${Math.random()}`}
                        checked={i.checked}
                        onChange={(e) => {
                          i.checked = !i.checked;
                          // currentValue.checked = !currentValue.checked;
                          this.setState({});
                          this.props.onChange && this.props.onChange();
                        }}
                        color="primary"
                      />
                    }
                    label={i.type}
                    labelPlacement="end"
                  />
                ))}
              </div>
            )}

            {/* {c.transparency && <OpacitySlider layer={l} />} */}
          </MiniPanel>
        </div>
      </>
    );
  }
}

export default SearchUI;
